import { TwinEmployeeParametersDict } from '@teinor/erp/types/company/userInner/employeeParameter'
import { ButtonRedSecondary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { LittleModalCreateEditOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalDeleteFilledOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import { Fragment } from 'react'
import { WorkingCenterPayload } from '../../../../../../../../utils/reducers/company/workingCenters'
import { SpecificPriceRulesPayload } from '../../../../../../../../utils/reducers/products/specificPriceRules'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import { CategoriesPayload } from '../../../../../../../../utils/reducers/products/categories'

interface ConfigWordpressCustomRenderProps {
    parameters: TwinParameters
    getData: () => Promise<void>
}

export const ConfigWordpressCustomRender: React.FC<ConfigWordpressCustomRenderProps> = ({ parameters, getData }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    let myRender = <ConfigureWordpress setOpenModal={setOpenModal} />
    if (parameters?.wordpressApi) {
        myRender = <ConfiguratedWordpress setOpenModal={setOpenModal} />
    }
    return (
        <Fragment>
            {myRender}
            {openModal?.type === 'edit' ? <ModalWordpressParametersConfigConnect onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
            {openModal?.type === 'delete' ? <ModalDeleteWordpressConfigQuote onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
        </Fragment>
    )
}

interface ConfiguratedWordpressProps {
    setOpenModal: SetEditDeleteModalTy
}

const ConfiguratedWordpress: React.FC<ConfiguratedWordpressProps> = ({ setOpenModal }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <div className='flex gap-x-5'>
                <TwinTrans transKey={'wordpressConfigured'}>Wordpress configurado</TwinTrans>
            </div>
            <ButtonRedSecondary className='w-fit ml-10' type='button' onClick={() => setOpenModal({ type: 'delete', allRowData: {} })} key={'deleteWordpressConfig'}><TwinTrans transKey={'deleteWordpressConfig'}>Borrar configuración de wordpress</TwinTrans></ButtonRedSecondary>
        </div>
    )
}

interface ConfigureWordpressProps {
    setOpenModal: SetEditDeleteModalTy
}
const ConfigureWordpress: React.FC<ConfigureWordpressProps> = ({ setOpenModal }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <span><TwinTrans transKey={'wordpressParametersConfig'}>Configurar parámetros de wordpress</TwinTrans>:</span>
            <ButtonSecondary className='w-fit' type='button' onClick={() => setOpenModal({ type: 'edit', allRowData: {} })} key={'configWordpress'}><TwinTrans transKey={'Config'}>Configurar</TwinTrans></ButtonSecondary>
        </div>
    )
}

interface ModalDeleteWordpressConfigQuoteProps extends ModalEditComponentProps { }

const ModalDeleteWordpressConfigQuote: React.FC<ModalDeleteWordpressConfigQuoteProps> = ({ setOpened, onSubmit }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/parameter/deleteParameters',
        data: {
            parameters: ['wordpressApi', 'wordpressSite']
        }
    })

    return (
        <ModalDeleteFilledOutside opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteWordpressConfig', '¿Seguro que quieres borrar la configuración de wordpress?'),
            subtitle: t('YouWillBeAbleToConfigItAgain', 'Podrás volver a configurarla de nuevo'),
            buttonAccept: t('delete', 'Borrar'),
        }} />
    )
}

interface ModalWordpressParametersConfigProps extends ModalEditComponentProps { }

const ModalWordpressParametersConfig: React.FC<ModalWordpressParametersConfigProps & ReduxModalWordpressParametersConfigConnector> = ({ setOpened, onSubmit, workingCenters, specificPriceRules, categories }) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<TwinEmployeeParametersDict> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'wordpressApiCustomer',
                    label: t('wordpressApiClient', 'Api de Wordpress Cliente'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'wordpressApiSecret',
                    label: t('wordpressApiSecret', 'Api de Wordpress Secreta'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'wordpressSite',
                    label: t('wordpressUrl', 'URL de Wordpress'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'wordpressWorkingCenterId',
                    label: t('wordpressWorkingCenterId', 'Centro de Wordpress'),
                    component: 'CustomSelectWithSearchBar',
                    items: workingCenters || {},
                    required: true
                },
                {
                    name: 'wordpressSpecificRuleId',
                    label: t('wordpressSpecificRuleId', 'Precios de Wordpress'),
                    component: 'CustomSelectWithSearchBar',
                    items: specificPriceRules?.dictionary || {},
                    required: true
                },
                {
                    name: 'wordpressCategoryId',
                    label: t('wordpressCategoryId', 'Categorias de Wordpress'),
                    component: 'CustomSelectWithSearchBar',
                    items: categories?.dictionary || {},
                    required: true
                },
            ]
        },
    ]
    return (
        <LittleModalCreateEditOutside className={'flex flex-col'} fields={fields} setOpened={setOpened} url={'/api/app/config/parameter/updateParameters'} translations={{
            title: t('parameters', 'Parámetros'),
            button: t('save', 'Guardar')
        }} haveButtonPermissions={true} onSubmit={onSubmit} />
    )
}

const modalWordpressParametersConfigDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
    setCategories: (payload: CategoriesPayload) => ({ type: 'CHANGE_CATEGORIES', payload }),
}
const mapModalWordpressParametersConfigConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, specificPriceRules: state.specificPriceRules, categories: state.categories })
const modalWordpressParametersConfigConnector = connect(mapModalWordpressParametersConfigConnector, modalWordpressParametersConfigDispatch)
type ReduxModalWordpressParametersConfigConnector = ConnectedProps<typeof modalWordpressParametersConfigConnector>

const modalWordpressParametersConfigConnectLoading = withLoading(ModalWordpressParametersConfig, [{ fetchUrl: '/api/app/product/category/getAllCategories', propName: 'categories', setFunctionName: 'setCategories' }, { fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }])

const ModalWordpressParametersConfigConnect = modalWordpressParametersConfigConnector(modalWordpressParametersConfigConnectLoading)